import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './notable-likes-arrow.scss';

type Props = {
  direction: 'prev' | 'next',
  isDisabled: boolean,
  onScroll: (event: React.MouseEvent<HTMLElement>) => void
};

const ICONS = {
  prev: 'chevron-left-custom-fg',
  next: 'chevron-right-custom-fg'
};

const NotableLikesArrow = ({
  direction,
  isDisabled,
  onScroll
}: Props
): JSX.Element => {
  const containerClasses = classnames('notable-likes-arrow', {
    [`notable-likes-arrow--direction-${direction}`]: Boolean(direction)
  });

  const arrowClasses = classnames('notable-likes-arrow__arrow', {
    [`notable-likes-arrow__arrow--direction-${direction}`]: Boolean(direction),
    'notable-likes-arrow__arrow--is-disabled': isDisabled
  });

  return (
    <div className={containerClasses}>
      <div
        className={arrowClasses}
        onClick={!isDisabled ? onScroll : undefined}
        data-direction={direction}
      >
        <SVGDynamicIcon
          name={ICONS[direction]}
          width={14}
          height={26}
          customColor="grey"
        />
      </div>
    </div>
  );
};

export default NotableLikesArrow;
